// import { RootStore } from 'mobx-stores'
import { PaginationSearchBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { StoreDTO, StoreFilterDTO, StoreTableEntryDTO } from 'models'
import { Api, User } from 'services'
import { parseToNumberOrNull } from '@touche-lts/panel-ui/dist'
import {
  StoresTableSearchProps,
  StoresTableSortProps
} from './stores-table-store.types'
import {
  initialStoresTablePaginationProps,
  initialStoresTableSearchProps,
  storesTableNeedTimeoutSearchProps
} from './stores-table-store.utils'

export class StoresTableStore extends PaginationSearchBase<
  StoresTableSortProps,
  StoresTableSearchProps,
  StoreTableEntryDTO
> {
  private storeApi: Api['storeApi']

  constructor (rootStore: any) {
    super({
      initialPaginationProps: initialStoresTablePaginationProps,
      initialSearchProps: initialStoresTableSearchProps,
      needTimeoutProps: storesTableNeedTimeoutSearchProps
    })
    this.storeApi = rootStore.generalStore.api.storeApi
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    if (User.isStoreAdmin) {
      await this.triggerSearchForStoreAdmin()
      return
    }

    const data = await this.storeApi.getAllStoresFiltered(this.storeFilter, {
      pageQueryParams: {
        page: options?.resetPageNumber ? 0 : this.pagination.page,
        size: this.pagination.size,
        sortDirection: this.pagination.sortDirection,
        sortProp: this.pagination.sortProp
      }
    })
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content)
  }

  private triggerSearchForStoreAdmin = async (): Promise<void> => {
    const stores = await this.storeApi.getCurrentUserStores()
    if (!stores) return
    const tableEntries: StoreTableEntryDTO[] = stores.map(store => this.mapStoreToTableEntry(store))
    this.handleSearchResultPaginationProps({
      totalElements: tableEntries.length,
      totalPages: 1,
      size: tableEntries.length,
      number: 0,
    } as any)
    this.setSearchResults(tableEntries)
  }

  private mapStoreToTableEntry = (store: StoreDTO): StoreTableEntryDTO => ({
    id: store.id,
    name: store.name,
    email: store.email,
    country: store.address?.country || '',
    status: store.status,
    rating: store.rating || 0,
    createdDate: store.createdDate,
    image: store.images?.[0] || null,
    activeProducts: 0,
    sold: 0,
    totalRevenue: 0,
    totalVisitors: 0,
  })

  // COMPUTED
  private get storeFilter (): StoreFilterDTO {
    return {
      country: this.searchProps.country || null,
      email: this.searchProps.email,
      id: parseToNumberOrNull(this.searchProps.id),
      maxRating: this.searchProps.maxRating,
      maxRevenue: this.searchProps.maxRevenue,
      maxSold: this.searchProps.maxSold,
      minRating: this.searchProps.minRating,
      minRevenue: this.searchProps.minRevenue,
      minSold: this.searchProps.minSold,
      name: this.searchProps.name
    }
  }
}
